module.exports = __webpack_public_path__ + "static/media/Expense-Management.938699ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/general/Expense-Management.png
// module id = 113
// module chunks = 0